// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.token-selector-container {
  position: relative;
  display: inline-block;
}

.token-list,
.sub-token-list {
  position: absolute;
  z-index: 1000;
  width: 400px;
  height: 400px;
  background-color: white;
  /* Белый фон для списка */
  border: 1px solid #ddd;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  /* Небольшая тень для эффекта всплывающего окна */
  /* Ограничение максимальной высоты с прокруткой */
  overflow-y: auto;
}

.sub-token-list {
  margin-left: 20px;
  height: 600px;
}

@media (max-width: 748px) {
  .token-selector-container {
    position: static;
  }
  .token-list,
  .sub-token-list {
    width: 100%;
    right: auto;
    left: 0;
  }
}
.list-group-item {
  cursor: pointer;
  padding: 2px;
  margin: 4px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  text-align: center;
  font-size: 13px;
}

/* Остальные стили */
.btn-small {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

/* Стили для кнопки "Назад" */
.sub-token-list .btn-secondary {
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/token-selector/token-selector.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,kBAAA;EACA,qBAAA;AAEJ;;AAEA;;EAEI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,iDAAA;EACA,iDAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,aAAA;AACJ;;AAEA;EAEI;IACI,gBAAA;EAAN;EAGE;;IAEI,WAAA;IACA,WAAA;IACA,OAAA;EADN;AACF;AAIA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAFJ;;AAMA,oBAAA;AAEA;EACI,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAJJ;;AAOA,6BAAA;AACA;EACI,mBAAA;AAJJ","sourcesContent":[".token-selector-container {\n    position: relative;\n    display: inline-block;\n\n}\n\n.token-list,\n.sub-token-list {\n    position: absolute;\n    z-index: 1000;\n    width: 400px;\n    height: 400px;\n    background-color: white;\n    /* Белый фон для списка */\n    border: 1px solid #ddd;\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);\n    /* Небольшая тень для эффекта всплывающего окна */\n    /* Ограничение максимальной высоты с прокруткой */\n    overflow-y: auto;\n}\n\n.sub-token-list {\n    margin-left: 20px;\n    height: 600px;\n}\n\n@media (max-width: 748px) {\n\n    .token-selector-container {\n        position: static;\n    }\n\n    .token-list,\n    .sub-token-list {\n        width: 100%; // Во всю ширину экрана на мобильных устройствах\n        right: auto; // Сброс позиционирования справа\n        left: 0; // Позиционирование слева\n    }\n}\n\n.list-group-item {\n    cursor: pointer;\n    padding: 2px;\n    margin: 4px;\n    background-color: #f8f9fa;\n    border: 1px solid #ddd;\n    text-align: center;\n    font-size: 13px;\n}\n\n// token-selector.component.scss\n/* Остальные стили */\n\n.btn-small {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n}\n\n/* Стили для кнопки \"Назад\" */\n.sub-token-list .btn-secondary {\n    margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
